import { render, staticRenderFns } from "./LayoutMobilel.vue?vue&type=template&id=6485ab81&"
import script from "./LayoutMobilel.vue?vue&type=script&lang=js&"
export * from "./LayoutMobilel.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMobilel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports